import React, { FC, ReactNode, FormHTMLAttributes } from "react";

// Third party
import { UseFormReturn, FormProvider as RHFProvider } from "react-hook-form";

type TFormProvider = {
  children: ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
} & FormHTMLAttributes<HTMLFormElement>;

const FormProvider: FC<TFormProvider> = ({ children, onSubmit, methods, ...formProps }) => {
  return (
    <RHFProvider {...methods}>
      <form onSubmit={onSubmit} {...formProps}>
        {children}
      </form>
    </RHFProvider>
  );
};

export { FormProvider };
